import { createChildFormViewContainer } from 'factories/ChildFormView'
import actions from 'actions/orders/orderItems'
import jobActions from 'actions/jobs'
import assetActions from 'actions/assets'
import operatorActions from 'actions/operators'
import tagListActions from 'actions/tagLists'
import orderActions from 'actions/orders'
import Component from 'components/Orders/Items/FormView'

export default createChildFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getJobs: (params) => dispatch(jobActions.getOptions({ pageIndex: 0, ...params })),
    getJob: (jobId) => dispatch(jobActions.getItem(jobId)),
    getAssets: (params) => dispatch(assetActions.getOptions({ pageIndex: 0, ...params })),
    getAsset: (assetId) => dispatch(assetActions.getItem(assetId)),
    getOperators: (params) => dispatch(operatorActions.getOptions({ pageIndex: 0, ...params })),
    getOperator: (operatorId) => dispatch(operatorActions.getItem(operatorId)),
    getTagLists: () => dispatch(tagListActions.getItemsOffline()),
    getOrder: (orderId) => dispatch(orderActions.getItem(orderId)),
    populateOrderItems: (params) => dispatch(actions.populateOrderItems(params)),
  }),
})(Component)
